<template>
  <div class="game-bgm-s">
    <div class="ip-info">Your local IP address is {{ localIp }}</div>
    <div>
      <button class="btn btn-primary" v-if="!open" @click="bmgplay(true)">Open</button>
      <button class="btn btn-disable" v-else @click="bmgplay(false)">Close</button>
      <label for="game_bgm">Set background music</label>
      <select id="game_bgm" @change="playMoreMusic()">
        <option value="001" selected>One</option>
        <option value="002">Two</option>
        <option value="003">Three</option>
      </select>
    </div>
    <div style="display: none">
      <audio id="BgmAudio" controls="controls" loop="loop">
        <source :src="bgm_name" type="audio/mpeg" />
      </audio>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { Loading } from "vant";
Vue.use(Loading);
import axios from "axios";
export default {
  props: {},
  data() {
    return {
      bgm_name: require("@/assets/music/bgm/001.mp3"),
      localIp: "",
      open: false,
    };
  },
  methods: {
    playMoreMusic() {
      let b = document.getElementById("game_bgm").value;
      this.bgm_name = require("@/assets/music/bgm/" + b + ".mp3");
      if (this.open) {
        document.getElementById("BgmAudio").load();
        document.getElementById("BgmAudio").play();
      }
    },
    bmgplay(flag) {
      this.open = flag;
      let bgmaudio = document.getElementById("BgmAudio");
      if (bgmaudio) {
        bgmaudio.load();
        if (flag) bgmaudio.play();
        else bgmaudio.pause();
      }
    },
    showLocalIp() {
      axios.get(this.api.api_findLocalIp, null).then((res) => {
        if (res.data.code == 0) this.localIp = res.data.data;
      });
    },
  },
  created() {
    this.showLocalIp();
  },
};
</script>

<style lang="scss" scoped>
.game-bgm-s {
  text-align: center;
  font-size: 0.36rem;
  position: absolute;
  left: 0;
  right: 0;
  top: 10px;
  margin: auto;
  z-index: 2;
  .ip-info {
    color: white;
  }
  label {
    color: white;
    padding: 0 10px;
  }
  select {
    width: 65px;
    height: 30px;
    padding: 0 4px;
  }
}
</style>